import React from "react";
import { Menu } from "antd";
import { Sling as Hamburger } from "hamburger-react";
import Sider from "antd/es/layout/Sider";
import logo from "../../../assets/logo.png";
import { UserOutlined } from "@ant-design/icons";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const MobileSiderMenu = ({ open, setOpen }) => {
  return (
    <motion.div
      initial={{ right: -400, opacity: 0 }}
      animate={open ? { right: 0, opacity: 1 } : { right: -400, opacity: 0 }}
      className="absolute"
    >
      <Sider trigger={null} className="h-screen">
        <div className="p-2 flex items-center">
          <Link to="/">
            {" "}
            <img src={logo} className="w-32" alt="logo" />
          </Link>
          <Hamburger
            color="#ffcc46"
            toggled={open}
            toggle={() => setOpen(!open)}
          />
        </div>

        <Menu
          theme="dark"
          mode="inline"
          defaultSelectedKeys={["1"]}
          items={[
            {
              key: "1",
              icon: (
                <Link to="/" className="p-2 ">
                  <UserOutlined />
                </Link>
              ),
              label: "Dashboard",
            },
            // {
            //   key: "2",
            //   icon: <VideoCameraOutlined />,
            //   label: "nav 2",
            // },
            // {
            //   key: "3",
            //   icon: <UploadOutlined />,
            //   label: "nav 3",
            // },
          ]}
        />
      </Sider>
    </motion.div>
  );
};
export default MobileSiderMenu;
